import axios from 'axios';
import serviceconfig from './serviceConfig';

export default {
  async authenticate(username, password) {
    const logininfo = { username, password };
    return axios.post(`${serviceconfig.apiBase}/auth/basic`, logininfo);
  },
};
